import { defineMessages } from "react-intl";

export const ONBOARDING_WORKFLOW_MESSAGES = defineMessages({
  stepBusinessCountry: {
    id: "onboarding-workflow-tracker: step business country",
    defaultMessage: "Business country",
  },
  stepMonthlyRevenue: {
    id: "onboarding-workflow-tracker: step monthly revenue",
    defaultMessage: "Monthly revenue",
  },
  stepBusinessDetails: {
    id: "onboarding-workflow-tracker: step business details",
    defaultMessage: "Business details",
  },
  stepConnectionsAndData: {
    id: "onboarding-workflow-tracker: step connections and data",
    defaultMessage: "Connections and data",
  },
  stepApplicationReview: {
    id: "onboarding-workflow-tracker: step application review",
    defaultMessage: "Application review",
  },
  stepBusinessCountryDescription: {
    id: "onboarding-workflow-tracker: step business country description",
    defaultMessage: "This lets us confirm availability and show you terms specific to your country.",
  },
  stepMonthlyRevenueDescription: {
    id: "onboarding-workflow-tracker: step monthly revenue description",
    defaultMessage: "Your monthly revenue helps us check if we're a good fit for your business.",
  },
  stepBusinessDetailsDescription: {
    id: "onboarding-workflow-tracker: step business details description",
    defaultMessage: "We'll take a quick look at your business details and activity.",
  },
  stepConnectionsAndDataDescription: {
    id: "onboarding-workflow-tracker: step connections and data description",
    defaultMessage: "We use your data to understand your business's financial health.",
  },
  stepApplicationReviewDescription: {
    id: "onboarding-workflow-tracker: step application review description",
    defaultMessage: "We'll review your application and get back to you soon.",
  },
  stepBusinessCountrySubtext: {
    id: "onboarding-workflow-tracker: step business country subtext",
    defaultMessage: "Avg. 10 secs",
  },
  stepMonthlyRevenueSubtext: {
    id: "onboarding-workflow-tracker: step monthly revenue subtext",
    defaultMessage: "Avg. 15 secs",
  },
  stepBusinessDetailsSubtext: {
    id: "onboarding-workflow-tracker: step business details subtext",
    defaultMessage: "Avg. 30 secs",
  },
  stepConnectionsAndDataSubtext: {
    id: "onboarding-workflow-tracker: step connections and data subtext",
    defaultMessage: "Avg. 6 min",
  },
  stepApplicationReviewSubtext: {
    id: "onboarding-workflow-tracker: step application review subtext",
    defaultMessage: "Avg. 10 secs",
  },
  substepBusinessLocation: {
    id: "onboarding-workflow-tracker: substep business location",
    defaultMessage: "Business location",
  },
  substepBusinessInformation: {
    id: "onboarding-workflow-tracker: substep business information",
    defaultMessage: "Business information",
  },
  substepBusinessModel: {
    id: "onboarding-workflow-tracker: substep business model",
    defaultMessage: "Business model",
  },
  substepBankAccounts: {
    id: "onboarding-workflow-tracker: substep bank accounts",
    defaultMessage: "Bank accounts",
  },
  substepPlatforms: {
    id: "onboarding-workflow-tracker: substep platforms",
    defaultMessage: "Platforms",
  },
  substepSusa: {
    id: "onboarding-workflow-tracker: substep susa",
    defaultMessage: "SuSa",
  },
  substepPoolBancario: {
    id: "onboarding-workflow-tracker: substep pool bancario",
    defaultMessage: "Pool bancario",
  },
  substepManagementAccounts: {
    id: "onboarding-workflow-tracker: substep management accounts",
    defaultMessage: "Management accounts",
  },
  substepProfitAndLoss: {
    id: "onboarding-workflow-tracker: substep profit and loss",
    defaultMessage: "Profit & loss",
  },
  substepBalanceSheet: {
    id: "onboarding-workflow-tracker: substep balance sheet",
    defaultMessage: "Balance sheet",
  },
  substepDebtAgreements: {
    id: "onboarding-workflow-tracker: substep debt agreements",
    defaultMessage: "Debt agreements",
  },
  substepRevenueProjections: {
    id: "onboarding-workflow-tracker: substep revenue projections",
    defaultMessage: "Revenue projections",
  },
  substepSoftCreditCheck: {
    id: "onboarding-workflow-tracker: substep soft credit check",
    defaultMessage: "Soft credit check",
  },
  footerWorkflowHelpHeading: {
    id: "onboarding-workflow-tracker: footer workflow help heading",
    defaultMessage: "Having trouble?",
  },
  footerWorkflowContact: {
    id: "onboarding-workflow-tracker: footer workflow contact",
    defaultMessage: "<p>Visit our <a1>help center</a1></p>",
  },
  footerWorkflowBankingContact: {
    id: "onboarding-workflow-tracker: footer workflow banking contact",
    defaultMessage: "<p>Learn more about why we need to <a1>connect to your bank accounts</a1>.</p>",
  },
  footerWorkflowCreditCheckContact: {
    id: "onboarding-workflow-tracker: footer workflow credit check contact",
    defaultMessage: "<p>Learn more about <a1>required documents</a1>.</p>",
  },
  footerWorkflowPlatformsContact: {
    id: "onboarding-workflow-tracker: footer workflow platforms contact",
    defaultMessage: "<p>Learn more about why we need <a1>access to your platforms</a1>.</p>",
  },
  footerWorkflowLegal: {
    id: "onboarding-workflow-tracker: footer workflow legal",
    defaultMessage: "<p><a1>Terms of Business</a1> · <a2>Privacy Policy</a2></p>",
  },
});
